module.exports = __webpack_public_path__ + "static/media/loinc.742c7ec2.png";